<template lang="pug">
    control-modal-layout.select-option-modal(v-bind="$attrs" :offsetX="offsetX" :offsetY="8" :placement="placement" ref="modal")
        div.select-option-modal__list
            div.select-option-modal__item(v-for="option in options" :class="getItemClass(option)" @click="optionSelect(option)") {{ option.name }}
</template>

<script>
export default {
    name: 'select-option-modal',
    props: {
        options: {
            type: Array,
            required: true,
        },
        selected: {
            type: String,
        },
        handler: {
            type: Function,
            required: true,
        },
        offsetX: {
            type: Number,
            default: 0,
        },
        placement: {
            type: String,
            default: 'bottom-start',
        },
    },
    methods: {
        optionSelect(option) {
            this.$refs.modal.close()
            this.handler(option)
        },

        getItemClass(option) {
            return {
                'select-option-modal__item--selected': option.value == this.selected,
            }
        },
    },
}
</script>